import { colorPalette } from "../../shared/utils/constants";

export const customStyles = {
  coverImageContainer: {
    position: "relative" as const,
    width: "100%",
    height: "400px",
    overflow: "hidden",
  },
  coverImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
  },
  coverOverlay: {
    position: "absolute" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  coverTitle: {
    color: colorPalette.white,
    fontFamily: "'Bebas Neue', sans-serif",
    textAlign: "center" as const,
    textTransform: "uppercase" as const,
    letterSpacing: "2px",
    padding: "0 20px",
  },
  contentContainer: {
    py: 6,
    px: 4,
    minHeight: "50vh",
  },
  sectionTitle: {
    color: colorPalette.sectionTitle,
    fontFamily: "'Bebas Neue', sans-serif",
    marginBottom: "24px",
    borderBottom: `3px solid ${colorPalette.sectionTitle}`,
    paddingBottom: "12px",
  },
  description: {
    lineHeight: 1.8,
    marginBottom: "24px",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 200,
  },
  ctaSection: {
    backgroundColor: "#f5f5f5",
    padding: "32px",
    borderRadius: "8px",
    textAlign: "center" as const,
    marginTop: "48px",
  },
  ctaTitle: {
    color: colorPalette.sectionTitle,
    fontFamily: "'Bebas Neue', sans-serif",
    marginBottom: "16px",
  },
  ctaText: {
    marginBottom: "24px",
    fontSize: "16px",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 200,
  },
  buttonGroup: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap" as const,
  },
  callButton: {
    backgroundColor: colorPalette.sectionTitle,
    color: colorPalette.white,
    padding: "12px 32px",
    fontSize: "16px",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: colorPalette.headerBackground,
    },
  },
  backButton: {
    borderColor: colorPalette.sectionTitle,
    color: colorPalette.sectionTitle,
    padding: "12px 32px",
    fontSize: "16px",
    fontWeight: "bold",
    "&:hover": {
      borderColor: colorPalette.headerBackground,
      color: colorPalette.headerBackground,
      backgroundColor: "rgba(23, 84, 96, 0.05)",
    },
  },
  otherServicesSection: {
    backgroundColor: "#f9f9f9",
    padding: "60px 0",
    marginTop: "40px",
    "& .carousel-container": {
      padding: "20px 40px",
    },
    "& .carousel-item-padding": {
      padding: "0 8px",
    },
  },
  otherServicesTitle: {
    color: colorPalette.sectionTitle,
    fontFamily: "'Bebas Neue', sans-serif",
    textAlign: "center" as const,
    marginBottom: "40px",
    fontSize: "36px",
  },
  serviceCard: {
    height: "320px",
    display: "flex",
    flexDirection: "column" as const,
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    },
  },
  serviceCardImage: {
    objectFit: "cover" as const,
    objectPosition: "center top" as const,
    height: "150px",
    flexShrink: 0,
  },
  serviceCardTitle: {
    color: colorPalette.sectionTitle,
    fontFamily: "'Bebas Neue', sans-serif",
    fontSize: "20px",
    marginBottom: "8px",
    minHeight: "50px",
    display: "flex",
    alignItems: "center",
  },
  serviceCardDescription: {
    fontSize: "14px",
    lineHeight: 1.6,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical" as const,
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 200,
  },
  carouselNavButton: {
    backgroundColor: colorPalette.sectionTitle,
    color: colorPalette.white,
  },
};
